import React, { useEffect, useState } from 'react';
import { parseSupportToken, tokenFromHash } from '../utils/supportSession';

/**
 * Entrada de um acesso de suporte aberto no portal de plataforma (/suporte#t=<token>).
 * Guarda a sessão como uma sessão do portal do ginásio, tira o token do endereço e segue para o painel.
 * O servidor volta a validar a assinatura, o ginásio e o papel em cada pedido; isto só prepara o ecrã.
 */
export default function SupportEntry({ go = (path) => window.location.replace(path) }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = tokenFromHash(window.location.hash);
    // Sai do endereço (e do histórico) antes de mais nada: o token não deve ficar numa barra de endereço.
    try { window.history.replaceState(null, '', window.location.pathname); } catch { /* sem history */ }

    const parsed = token ? parseSupportToken(token) : { ok: false, error: 'Falta o acesso de suporte no endereço.' };
    if (!parsed.ok) { setError(parsed.error); return; }

    try {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(parsed.user));
      localStorage.removeItem('permissions');
    } catch {
      setError('Não foi possível guardar a sessão neste navegador.');
      return;
    }
    go('/admin');
  }, [go]);

  return (
    <div className="loading" style={{ padding: '2rem', textAlign: 'center' }} data-testid="support-entry">
      {error ? <p role="alert">{error}</p> : <p>A abrir a sessão de suporte…</p>}
    </div>
  );
}
